import moment from 'moment';
import React from 'react';

interface IDetailsBox {
    totalTransations?: number;
    matchRate?: any;
    mothlyBankRecon?: any;
    unmatchedValue?: any;
    monthlyDate?: any;
    unmatchedTransactions?: number;
    onClickMonthlyRecon: () => void;
    onClickUnmatchedItems: () => void;
}

const DetailsBox = ({
    totalTransations,
    matchRate,
    unmatchedValue,
    mothlyBankRecon,
    unmatchedTransactions,
    monthlyDate,
    onClickMonthlyRecon,
    onClickUnmatchedItems
}: IDetailsBox) => {

    const formatNumber = (value: number | string | null | undefined): any => {
        if (value === null || value === undefined || value === '') return 0;

        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(num)) return '';

        return num.toLocaleString('en-US');
    };

    const formatMonthLabel = (date: Date): string => {
        return moment(date).isSame(moment(), 'month')
            ? 'This Month'
            : moment(date).format('MMM YYYY');
    };

    return (
        <div className='my-3'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4'>
                <div className='rounded-xl p-3 border border-1 border-[#6366F1] h-full flex flex-col justify-between'>
                    <p className='font-bold my-3 dark:text-primary-dark'>Total transactions processed</p>
                    <p className='font-bold text-xl xl:text-2xl mt-auto dark:text-primary-dark'>{formatNumber(totalTransations || 0)}</p>
                </div>
                <div
                    onClick={onClickMonthlyRecon}
                    className='rounded-xl p-3 border border-1 border-[#6366F1] h-full flex flex-col justify-between cursor-pointer hover:opacity-80'>
                    <p className='font-bold my-3 dark:text-primary-dark'>Monthly Bank Reconciliation</p>
                    <div className='flex flex-row justify-between items-end'>
                        <p className='font-bold text-xl xl:text-2xl mt-auto dark:text-primary-dark'>{formatNumber(mothlyBankRecon || 0)}</p>
                        <p className='text-primary-light'>{formatMonthLabel(monthlyDate)}</p>
                    </div>
                </div>
                <div className='rounded-xl p-3 border border-1 border-[#10B981] h-full flex flex-col justify-between'>
                    <p className='font-bold my-3 dark:text-primary-dark'>Match rate (%)</p>
                    <p className='font-bold text-xl xl:text-2xl text-[#10B981] mt-auto'>{(matchRate || 0)}</p>
                </div>
                <div
                    onClick={onClickUnmatchedItems}
                    className='rounded-xl p-3 border border-1 border-[#EF4444] h-full flex flex-col justify-between cursor-pointer hover:opacity-80'>
                    <p className='font-bold my-3 dark:text-primary-dark'>Total unmatched value</p>
                    <p className='font-bold text-xl xl:text-2xl text-[#EF4444] mt-auto'>€{formatNumber(unmatchedValue || 0)}</p>
                </div>
                <div
                    onClick={onClickUnmatchedItems}
                    className='rounded-xl p-3 border border-1 border-[#EF4444] h-full flex flex-col justify-between cursor-pointer hover:opacity-80'>
                    <p className='font-bold my-3 dark:text-primary-dark'>Count of unmatched Transaction</p>
                    <p className='font-bold text-xl xl:text-2xl text-[#EF4444] mt-auto'>{formatNumber(unmatchedTransactions || 0)}</p>
                </div>
            </div>
        </div>
    )
}

export default DetailsBox;